import Swal from 'sweetalert2';

const PENDING_ORDER_SUCCESS_KEY = 'carta_pending_wpp_order_success';

export function savePendingWhatsappOrderSuccess(orderNumber) {
  sessionStorage.setItem(PENDING_ORDER_SUCCESS_KEY, String(orderNumber));
}

export function clearPendingWhatsappOrderSuccess() {
  sessionStorage.removeItem(PENDING_ORDER_SUCCESS_KEY);
}

export function getPendingWhatsappOrderSuccess() {
  return sessionStorage.getItem(PENDING_ORDER_SUCCESS_KEY);
}

export function showWhatsappOrderSuccessModal(orderNumber, confirmButtonColor) {
  if (Swal.isVisible()) return;

  Swal.fire({
    icon: 'success',
    title: '¡Pedido realizado!',
    html: `
      <p>Tu pedido fue enviado con éxito por WhatsApp.<br>
      <strong>Nro de pedido:</strong> <span id="orderNumberWpp">${orderNumber}</span></p>
      <p style="color: #7c7c7c; font-weight: 500;">⚠ No olvides guardar tu número de pedido.</p>
      <button id="copyBtnWpp" style="padding: 5px 10px; border-radius: 5px; cursor: pointer;">
        Copiar número
      </button>
    `,
    showConfirmButton: true,
    confirmButtonText: 'OK',
    confirmButtonColor,
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      const copyBtn = Swal.getPopup().querySelector('#copyBtnWpp');
      copyBtn.addEventListener('click', (event) => {
        event.stopPropagation();
        const orderText = document.getElementById('orderNumberWpp').innerText;
        navigator.clipboard.writeText(orderText).then(() => {
          copyBtn.style.backgroundColor = '#28a745';
          copyBtn.style.color = 'white';
          copyBtn.innerText = 'Copiado ✔';
          copyBtn.disabled = true;
        });
      });
    },
  }).then((result) => {
    if (result.isConfirmed) {
      clearPendingWhatsappOrderSuccess();
    }
  });
}

export function restoreWhatsappOrderSuccessModalIfNeeded(confirmButtonColor) {
  const orderNumber = getPendingWhatsappOrderSuccess();
  if (!orderNumber || Swal.isVisible()) {
    return;
  }

  showWhatsappOrderSuccessModal(orderNumber, confirmButtonColor);
}
